import { API, graphqlOperation } from "aws-amplify";
import * as mutations from "../graphql/mutations/applications";
import * as queries from "../graphql/queries/applications";
import UsersAPI from "./UsersAPI";

class ApplicationsAPI implements IApplicationsAPI {
  /**
   * Fetch a refresh token to be used by custom applications
   * this token will work only to get accessTokens and not to
   * execute backend application's handlers
   *
   * @returns {string} refreshToken
   */
  async getKetricsApplicationsRefreshToken() {
    try {
      const { refreshToken } = (await API.post("api", "/auth/refresh", {})) as {
        refreshToken: string;
      };
      localStorage.setItem("KetricsApplicationsRefreshToken", refreshToken);
      return refreshToken;
    } catch (e) {
      throw e;
    }
  }

  async adminListApplications() {
    try {
      const response: any = await API.graphql(graphqlOperation(queries.adminListApplications, {}));
      const applications = (response.data.adminListApplications as IApplication[]).filter(
        (app) => app.active
      );

      applications.forEach((application) => {
        application.path = `/applications/${application.applicationId}`;
      });

      return applications;
    } catch (e) {
      throw e;
    }
  }

  async adminGetApplication(applicationId: string) {
    try {
      const response: any = await API.graphql(
        graphqlOperation(queries.adminGetApplication, { applicationId })
      );
      return response.data.adminGetApplication as IApplication;
    } catch (e) {
      throw e;
    }
  }

  async adminUpdateApplication(application: IApplication) {
    try {
      const response: any = await API.graphql(
        graphqlOperation(mutations.adminUpdateApplication, { input: application })
      );
      return response.data.adminUpdateApplication as IApplication;
    } catch (e) {
      throw e;
    }
  }

  async adminCreateApplication(application: IApplication) {
    try {
      const { applicationId, ...$application } = application;
      const response: any = await API.graphql(
        graphqlOperation(mutations.adminCreateApplication, { input: $application })
      );
      return response.data.adminCreateApplication as IApplication;
    } catch (e) {
      throw e;
    }
  }

  async adminDeleteApplication(applicationId: string) {
    try {
      const response: any = await API.graphql(
        graphqlOperation(mutations.adminDeleteApplication, { applicationId })
      );
      return response.data.adminDeleteApplication as IApplication;
    } catch (e) {
      throw e;
    }
  }

  async adminUploadApplication(applicationId: string, file: File) {
    try {
      const preSignedUrl = await UsersAPI.userGetUploadUrl({
        handler: "applications/code",
        applicationId,
        filename: file.name,
        contentType: "application/zip"
      });

      await fetch(preSignedUrl.url, {
        method: "PUT",
        body: file
      });
    } catch (e) {
      throw e;
    }
  }

  async userListApplications() {
    try {
      const response: any = await API.graphql(graphqlOperation(queries.userListApplications, {}));
      const applications = (response.data.userListApplications as IApplication[]).filter(
        (app) => app.active
      );

      applications.forEach((application) => {
        application.path = `/applications/${application.applicationId}`;
      });

      return applications;
    } catch (e) {
      throw e;
    }
  }

  async userGetApplication(applicationId: string) {
    try {
      const response: any = await API.graphql(
        graphqlOperation(queries.userGetApplication, { applicationId })
      );
      return response.data.userGetApplication as IApplication;
    } catch (e) {
      throw e;
    }
  }

  async adminUpdateApplicationUsers(applicationId: string, users: string[]) {
    try {
      await API.graphql(
        graphqlOperation(mutations.adminUpdateApplicationUsers, { applicationId, users })
      );
    } catch (e) {
      throw e;
    }
  }
}

export default new ApplicationsAPI();
